import { gql } from "@apollo/client";

const LANGUAGE_FRAGMENT = gql`
    fragment LanguageFragment on Language {
        _id
        code
        original_letter
        name
    }
`;

const LEVEL_LANGUAGE_FRAGMENT = gql`
    fragment LevelLanguageFragment on LevelLanguage {
        _id
        level
        score
    }
`;

export const GET_DATA_TRANSFORM_LANGUAGE_QUERY = gql`
    query GetAllLevelLanguage {
        getDataTransformLanguage {
            language {
                ...LanguageFragment
            }
            levelLanguage {
                ...LevelLanguageFragment
            }
        }
    }
    ${LANGUAGE_FRAGMENT}
    ${LEVEL_LANGUAGE_FRAGMENT}
`;

export const GET_DATA_LANGUAGE_PAGINATION_QUERY = gql`
    query GetWithPagination($pagination: Pagination, $sortBy: String, $query: String) {
        getWithPagination(pagination: $pagination, sortBy: $sortBy, query: $query) {
            docs {
                ...LanguageFragment
            }
            meta {
                totalDocs
                limit
                page
                nextPage
                prevPage
                totalPages
                hasPrevPage
                hasNextPage
                pagingCounter
            }
        }
    }
    ${LANGUAGE_FRAGMENT}
`;
export const GET_ALL_LANGUAGE_QUERY = gql`
    query GetAllLanguage {
        getAllLanguage {
            ...LanguageFragment
        }
    }
    ${LANGUAGE_FRAGMENT}
`;
